import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// 未捕捉エラーを画面に表示（デバッグ用。Script error. は他ドメイン起因のため無視）
window.addEventListener('error', (e) => {
  if (e.message === 'Script error.' && !e.filename) {
    console.warn('Third-party script error (ignored):', e);
    return;
  }
  const root = document.getElementById('root');
  if (root) root.innerHTML = `<div style="padding:2rem;font-family:monospace;background:#fef2f2;color:#991b1b;white-space:pre-wrap">エラー\n\n${e.message}\n\n${e.error?.stack ?? ''}</div>`;
});
window.addEventListener('unhandledrejection', (e) => {
  const msg = String(e.reason);
  if (msg.includes('Script error') || msg.includes('Turnstile')) {
    console.warn('Third-party promise rejection (ignored):', e.reason);
    e.preventDefault();
    return;
  }
  const root = document.getElementById('root');
  if (root) root.innerHTML = `<div style="padding:2rem;font-family:monospace;background:#fef2f2;color:#991b1b;white-space:pre-wrap">Promise拒否\n\n${msg}</div>`;
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
